import { createReduxModule } from "hooks-for-redux";
// import { useLongPolling } from "@/services/websocket";
// import { useLongPolling } from "../services/websocket";

export const ERROR_GAME_SYNC = 0; // used on server
export const ERROR_END_GAME_WRONG_ID = 1;
export const ERROR_TIME_UP_NOT_MY_TURN = 2;
export const ERROR_LEFT_GAME_STILL_THERE = 3;
export const ERROR_ELO_DONT_MATCH = 4;
export const ERROR_WON_LOWER_ELO = 5;
export const ERROR_TIME_FEN = 6;
export const ERROR_MOVE_RECIVED = 7;
export const ERROR_BOUNDRY = 8;
export const ERROR_CLOCK_STOPPED = 9;
export const ERROR_PLAYER = 10;
export const ERROR_WEBSOCKET_CONNECTION_TIMEOUT = 16;
export const ERROR_GAME_REVIEW_STALLED = 17;
export const ERROR_WEBSOCKET_LIVE_CLOSE = 18;
export const ERROR_WEBSOCKET_WATCHDOG_RECOVERY = 19;

const initialState = {
  last: null,
  max: null,
  min: null,
  sum: 0,
  count: 0,
  average: 0,
  error: 0,
  offline: 0,
  resends: 0,
  pings: [],
  pingStart: null,
  wsClose: 0,
  userWsClose: 0,
  wsCloseErrorMsg: "",
  wsError: 0,
  wsErrorMsg: "",
  retries: 0,
  clientDisconn: 0,
  disconnectTime: null,
  disconnectTimeStamp: null,
  timeSinceDisconnect: null,
  endTimestamp: null,
  reconnected: 0,
  reconnectFail: null,
  updateReceived: null,
  updateReceivedTimeStamp: null,
  gamePlayState: null,
  errorData: {
    v: "16",
    deviceInfo: {
      isMobile:
        process.browser &&
        /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
      platform: process.browser ? navigator.platform : "unknown",
    },
    connectionState: {
      visibilityState: process.browser ? document.visibilityState : "unknown",
      wasHidden: false,
      wasVisible: false,
      lastVisibilityChange: null,
      lastPageHide: null,
      lastPageShow: null,
      lastBeforeUnload: null,
      lastUnload: null,
      lastFocus: null,
      lastBlur: null,
    },
    eventSequence: {
      lastVisibilityChange: null,
      lastWsClose: null,
      lastPingSent: null,
      lastPongReceived: null,
      lastNetworkStateChange: null,
      timeSinceLastVisibilityChange: null,
      timeSinceLastPing: null,
      timeSinceLastPong: null,
    },
    networkState: process.browser
      ? navigator.onLine
        ? "online"
        : "offline"
      : "unknown",
    networkStateTime: null,
    networkStateOnClose: null,
    networkStateTimeOnClose: null,
    wsCloseIsPlaying: null,
    wsCloseTime: null,
    wsCloseGameId: null,
    websocketWatchdog: {
      reason: null,
      lastCheckAt: null,
      lastPingAt: null,
      lastPongAt: null,
      websocketOpenedAt: null,
      stalePongMs: null,
      openedForMs: null,
      readyState: null,
      url: null,
      reconnectCount: 0,
      networkState: null,
      visibilityState: null,
      effectiveType: null,
      downlink: null,
      rtt: null,
      saveData: false,
    },
  },
};

export const [
  usePings,
  {
    moveSent,
    moveConfirmed,
    reset,
    setErrorData,
    setError,
    setOffline,
    setWsClose,
    setWsError,
    setWsCloseErrorMsg,
    setWsErrorMsg,
    setRetries,
    resetRetries,
    setClientDisconn,
    setDisconnectTime,
    setReconnected,
    setReconnectFail,
    setUpdateReceived,
    setGamePlayState,
  },
  pingStore,
] = createReduxModule("ping", initialState, {
  moveSent: (state) => ({
    ...state,
    pingStart: Date.now(),
  }),
  moveConfirmed: (state) => {
    const last = Date.now() - state.pingStart;
    const max = state.max != null ? Math.max(state.max, last) : last;
    const min = state.min != null ? Math.min(state.min, last) : last;
    const sum = last + state.sum;
    const count = state.count + 1;
    const average = sum / count;
    const pings = [...state.pings, last];

    return {
      ...state,
      last,
      sum,
      max,
      min,
      count,
      average,
      pings,
    };
  },
  reset: () => initialState,
  setErrorData: (state, data) => ({
    ...state,
    errorData: { ...state.errorData, ...data },
  }),
  setError: (state, errorType) => {
    const endTimestamp = Date.now();
    // Only calculate timeSinceDisconnect if we have a disconnectTimeStamp
    const timeSinceDisconnect = state.disconnectTimeStamp
      ? endTimestamp - state.disconnectTimeStamp
      : null;
    return {
      ...state,
      timeSinceDisconnect,
      endTimestamp,
      error: state.error ? state.error * 10 + errorType : errorType,
    };
  },
  setOffline: (state) => ({
    ...state,
    offline: state.offline + 1,
  }),
  setWsClose: (state) => ({
    ...state,
    wsClose: state.wsClose + 1,
  }),
  setWsCloseErrorMsg: (state, msg) => ({
    ...state,
    wsCloseErrorMsg: msg,
  }),
  setWsError: (state) => ({
    ...state,
    wsError: state.wsError + 1,
  }),
  setWsErrorMsg: (state, msg) => ({
    ...state,
    wsErrorMsg: msg,
  }),
  setRetries: (state) => ({
    ...state,
    retries: state.retries + 1,
  }),
  resetRetries: (state) => ({
    ...state,
    retries: 0,
  }),
  setClientDisconn: (state) => ({
    ...state,
    clientDisconn: state.clientDisconn + 1,
  }),
  setReconnected: (state) => ({
    ...state,
    reconnected: state.reconnected + 1,
    disconnectTime: Date.now() - state.disconnectTimeStamp,
  }),
  setDisconnectTime: (state) => ({
    ...state,
    disconnectTimeStamp: Date.now(),
  }),
  setReconnectFail: (state, msg) => ({
    ...state,
    reconnectFail: msg,
  }),
  setUpdateReceived: (state, gameId) => ({
    ...state,
    updateReceived: gameId,
    updateReceivedTimeStamp: Date.now(),
  }),
  setGamePlayState: (state, gamePlayState) => ({
    ...state,
    gamePlayState,
  }),
});

// Initialize connection state tracking
function initializeConnectionTracking() {
  // Only initialize once
  if (typeof window === "undefined") return;

  document.addEventListener("visibilitychange", () => {
    const state = pingStore.getState();
    const now = Date.now();
    const wasHidden = document.visibilityState === "hidden";
    const wasVisible = document.visibilityState === "visible";

    setErrorData({
      connectionState: {
        ...state.errorData.connectionState,
        visibilityState: document.visibilityState,
        wasHidden: wasHidden || state.errorData.connectionState.wasHidden,
        wasVisible: wasVisible || state.errorData.connectionState.wasVisible,
        lastVisibilityChange: now,
      },
    });
  });

  window.addEventListener("pagehide", () => {
    const state = pingStore.getState();
    setErrorData({
      connectionState: {
        ...state.errorData.connectionState,
        lastPageHide: Date.now(),
      },
    });
  });

  window.addEventListener("pageshow", () => {
    const state = pingStore.getState();
    setErrorData({
      connectionState: {
        ...state.errorData.connectionState,
        lastPageShow: Date.now(),
      },
    });
  });

  window.addEventListener("beforeunload", () => {
    const state = pingStore.getState();
    setErrorData({
      connectionState: {
        ...state.errorData.connectionState,
        lastBeforeUnload: Date.now(),
      },
    });
  });

  window.addEventListener("focus", () => {
    const state = pingStore.getState();
    setErrorData({
      connectionState: {
        ...state.errorData.connectionState,
        lastFocus: Date.now(),
      },
    });
  });

  window.addEventListener("blur", () => {
    const state = pingStore.getState();
    setErrorData({
      connectionState: {
        ...state.errorData.connectionState,
        lastBlur: Date.now(),
      },
    });
  });
}

// Initialize tracking when module is loaded
process.browser && initializeConnectionTracking();

export function sendPingData() {
  import("./pingReporter")
    .then((module) => {
      module.sendPingData();
    })
    .catch(() => {
      console.log("load ping reporter failed");
    });
}

export interface SendGameReviewErrorPayload {
  gameId: string | null;
  phase: "stockfish" | "commentary" | "unknown";
  progress: number;
  errorMessage: string;
  stockfishTime?: number;
  commentaryTime?: number;
  totalMoves?: number;
  completedMoves?: number;
}

export interface SendWebsocketCloseErrorPayload {
  code: number;
  reason: string;
  wasClean: boolean;
  readyState: number | null;
  url: string | null;
  gameId: string | null;
  isPlaying: boolean;
  timestamp: number;
  sessionId: string | null;
}

export interface SendWebsocketWatchdogRecoveryPayload {
  phase: "game-info";
  timestamp: number;
  sessionId: string | null;
  recovery: Record<string, any>;
  game: {
    gameId: string | null;
    isPlaying?: boolean | null;
    halfMoveCount?: number | null;
    status?: number | string | null;
    result?: number | string | null;
  };
}

export function sendGameReviewError(payload: SendGameReviewErrorPayload) {
  import("./pingReporter")
    .then((module) => {
      module.sendGameReviewError(payload);
    })
    .catch(() => {
      console.log("load ping reporter failed");
    });
}

export function sendWebsocketCloseError(
  payload: SendWebsocketCloseErrorPayload
) {
  import("./pingReporter")
    .then((module) => {
      module.sendWebsocketCloseError(payload);
    })
    .catch(() => {
      console.log("load ping reporter failed");
    });
}

export function sendWebsocketWatchdogRecovery(
  payload: SendWebsocketWatchdogRecoveryPayload
) {
  import("./pingReporter")
    .then((module) => {
      module.sendWebsocketWatchdogRecovery(payload);
    })
    .catch(() => {
      console.log("load ping reporter failed");
    });
}
